import { cn } from 'common/utils'
import ClearbitLogoFor from './ClearbitLogoFor'

const DomainLogo = ({ domainKey, domain, size, className }) => {
  const src = null

  if (src)
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src}
        alt={`${domainKey} image`}
        className={cn(className, 'externalImage')}
        width={size || 'auto'}
      />
    )

  return (
    <ClearbitLogoFor domainKey={domainKey} size={size} className={className} />
  )
}

export default DomainLogo
